import { render, staticRenderFns } from "./mallViewAllList.vue?vue&type=template&id=27bc7afd&scoped=true"
import script from "./mallViewAllList.vue?vue&type=script&lang=js"
export * from "./mallViewAllList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bc7afd",
  null
  
)

export default component.exports